import { Invoice } from '../../../types/Invoice/Invoice';
import { TFunction } from 'i18next';
import { Data, Headers } from 'react-csv/lib/core';

export type ExportData = {
  data: Data;
  headers: Headers;
};
const createCsvStructure = (invoices: Invoice[], t: TFunction) => {
  const csvData: ExportData = {
    headers: [
      `${t('invoices:creation date')}`,
      `${t('invoices:invoice number')}`,
      `${t('invoices:invoice state')}`,
      `${t('invoices:amount')}`,
      `${t('invoices:debtor mail address')}`,
      `${t('invoices:debtor firstname')}`,
      `${t('invoices:debtor name')}`,
      `${t('invoices:debtor company name')}`,
      `${t('invoices:debtor street & house number')}`,
      `${t('invoices:debtor zipcode')}`,
      `${t('invoices:debtor city')}`,
      `${t('invoices:debtor country')}`,
      `${t('invoices:payment state')}`,
      `${t('invoices:payment method')}`,
    ],
    data: [],
  };

  invoices.forEach((invoice: Invoice) => {
    csvData.data.push([
      invoice.createdDateTimeUTC,
      invoice.invoiceNumber,
      invoice.status,
      invoice.total,
      invoice.debitor.emailAddress,
      invoice.debitor.firstName,
      invoice.debitor.lastName,
      invoice.debitor.companyName,
      invoice.debitor.address?.line,
      invoice.debitor.address?.zipCode,
      invoice.debitor.address?.city,
      invoice.debitor.address?.country,
      invoice.paymentStatus,
      invoice.paymentMethod,
    ]);
  });
  return csvData;
};

export { createCsvStructure };
